<template>
  <nav>
    <v-app-bar elevate-on-scroll app color="blue-grey lighten-5">
      <v-app-bar-nav-icon @click="atualizarDrawer(!drawer)"></v-app-bar-nav-icon>
      <v-toolbar-title class="barra-navegacao__logo">
        <v-img
          src="/logo-salum.png"
          alt="Salum Construções"
          contain
          max-height="36"
          max-width="128"
        ></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="sair" text>
        <span class="mr-2">Sair</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
      <menu-lateral/>
  </nav>
</template>

<script>
import { logout } from "../../services/loginService";
import MenuLateral from "./MenuLateral";
import { mapState, mapActions } from "vuex";
//import Logo from "../Logo";

export default {
  name: "barraNavegacao",
  computed: {
    ...mapState("sistema", ["drawer"]),
  },
  methods: {
    ...mapActions("sistema", ["atualizarDrawer"]),
    sair() {
      logout();
      this.$router.push("/login");
    },
    isAdmin() {
      var loggedIn = localStorage.getItem("user");
      return JSON.parse(loggedIn).admin;
    },
  },
  components: { MenuLateral },
};
</script>

<style scoped>
.barra-navegacao__logo {
  display: flex;
  align-items: center;
  width: 128px;
}
</style>
